import styled from 'styled-components';
import Theme from '../theme/Theme';

const GreyCard = styled.div`
  padding: 15px;
  background: ${Theme.gray8};
  position: relative;
  border-radius: 8px;
  line-height: 19px;

  &.light-grey-bg {
    background: ${Theme.gray1};
  }
  .contact-user-name {
    font-size: ${Theme.medium};
    color: ${Theme.gray90};
  }
  .icon-white-bg {
    font-size: 17px;
    color: ${Theme.gray90};
    background: ${Theme.white};
    border-radius: 4px;
    font-size: 17px;
    padding: 10px 9px;
    vertical-align: middle;
    border-radius: 4px;
    margin-right: 12px;
  }

  .small-black-text {
    color: ${Theme.black};
    font-size: ${Theme.extraNormal};
    font-weight: 600;
  }
  .user-details {
    color: ${Theme.gray35};
    font-size: 13px;

    img {
      width: 15px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
  .delete-contact {
    position: absolute;
    width: 16px;
    top: 15px;
    right: 20px;
  }
  .edit-contact {
    position: absolute;
    top: 14px;
    right: 50px;
    width: 14px;
  }

  &.yellow-card {
    background: ${Theme.lightYellow};
    color: ${(props) => (props.dsp ? 'black' : '')};

    .video-link {
      font-size: 14px;
      color: ${Theme.orange};
      text-transform: initial;
    }
  }
`;
export default GreyCard;
